export default () => {
  // Add new note row
  $('#offcanvasRight').on('click', '.add_note', function(event) {
    dirty = true

    var regexp, time
    time = new Date().getTime()
    regexp = new RegExp($(this).data('id'), 'g')
    const html = $(this).data('fields').replace(regexp, time)
    $(this).closest('.tab-pane').find('.note_rows').prepend(html)

    // Set date to today on new row
    const today = new Date()
    const d = String(today.getDate()).padStart(2, '0')
    const m = String(today.getMonth() + 1).padStart(2, '0')
    const y = today.getFullYear()
    $(this).closest('.tab-pane').find('.note_rows .note_row:first input[name*="[date]"]').val(`${d}.${m}.${y}`)

    $('.input-group .date input').datepicker()

    $(this).blur()

    return event.preventDefault()
  })

  // Remove note row
  $('#offcanvasRight').on('click', '.remove_note_row', function(event) {
    dirty = true

    $(this).prev('input[type=hidden]').val('1')
    $(this).closest('.note_row').addClass('d-none')

    return event.preventDefault()
  })
}
